const PrivacyPolicy = () => {
  return (
    <div data-testid="privacy-policy-page" className="pt-32 pb-20 bg-white">
      <div className="container-main">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-4xl text-[#2D2D2D] mb-8">Privacy Policy</h1>
          <p className="text-[#6E6E6E] mb-8">Last updated: December 2024</p>

          <div className="prose prose-gray max-w-none">
            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">1. Introduction</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                Decors Genius ("we," "our," or "us") respects your privacy and is committed to 
                protecting your personal data. This privacy policy explains how we collect, use, 
                and safeguard your information when you visit our website or use our services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">2. Information We Collect</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">We may collect the following types of information:</p>
              <ul className="list-disc list-inside text-[#6E6E6E] space-y-2 mb-4">
                <li>Personal identification information (name, email address, phone number)</li>
                <li>Project details and preferences you share with us</li>
                <li>Communication records between you and our team</li>
                <li>Website usage data through cookies and analytics</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">3. How We Use Your Information</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">We use the information we collect to:</p>
              <ul className="list-disc list-inside text-[#6E6E6E] space-y-2 mb-4">
                <li>Respond to your inquiries and consultation requests</li>
                <li>Provide and improve our decoration services</li>
                <li>Send relevant updates about your project</li>
                <li>Improve our website and user experience</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">4. Data Protection</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                We implement appropriate security measures to protect your personal information 
                from unauthorized access, alteration, disclosure, or destruction. However, no 
                method of transmission over the internet is 100% secure.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">5. Third-Party Sharing</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                We do not sell, trade, or rent your personal information to third parties. We may 
                share your information with trusted service providers who assist us in operating 
                our business, provided they agree to keep this information confidential.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">6. Your Rights</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">You have the right to:</p>
              <ul className="list-disc list-inside text-[#6E6E6E] space-y-2 mb-4">
                <li>Access the personal data we hold about you</li>
                <li>Request correction of inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Opt out of marketing communications</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">7. Contact Us</h2>
              <p className="text-[#6E6E6E] leading-relaxed">
                If you have questions about this Privacy Policy, please contact us at:<br />
                Email: support@decorsgenius.store<br />
                Phone: +1-888-880-1455
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
